// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"816d636c","105":"6022b2fd","212":"90eec372","400":"66374b16","453":"8ab44547","577":"e264128a","579":"022b10ba","786":"3b6b90d4","969":"83d73f36"}[chunkId] + ".chunk.js";
};